/* eslint-disable @nx/enforce-module-boundaries */
import { TIME_FORMATE } from 'v4/lib/data';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import React, { use } from 'react';
import { useState } from 'react';
import {
  Button,
  Checkbox,
  Textarea,
  Radio,
  Box,
  ModalBody,
  ModalFooter,
  RadioGroup,
  Text,
  VStack,
  Stack,
  Flex,
} from '@mybridge/ui';
import styles from '../calendarSnip.module.scss';
import Select, { components } from 'react-select';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';

const CalendarModalPopups = (props) => {
  const { modalType, setModalOpen, updateStatus, data } = props;
  const [commentMessage, setCommentMessage] = useState('');
  const [charCount, setCharCount] = useState(0);
  const { t } = useTranslator();
  const { push } = useRouter();
  // Function to handle textarea change with character count
  const handleTextareaChange = (e) => {
    const value = e.target.value;
    setCommentMessage(value);
    setCharCount(value.length);
  };
  const ary = Intl.supportedValuesOf('timeZone');
  const timeZone = ary.map((item) => {
    return { value: item, label: item };
  });

  const [timeZoneSelected, setTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  // const [fromDate, setFromDate] = useState(
  //   moment(new Date(data?.fromDate)).format('YYYY-MM-DD') ||
  //     moment(new Date()).format('YYYY-MM-DD')
  // );
  // const [toDate, setToDate] = useState(
  //   moment(new Date(data?.toDate)).format('YYYY-MM-DD') ||
  //     moment(new Date()).format('YYYY-MM-DD')
  // );
  const [fromDate, setFromDate] = useState(
    data?.fromDate ? new Date(data.fromDate) : new Date()
  );
  const [toDate, setToDate] = useState(
    data?.toDate ? new Date(data.toDate) : new Date()
  );
  let min = moment().minute();
  let dateTime = moment()
    .add(min > 30 && 1, 'hours')
    .minutes(min <= 30 ? 30 : 0)
    .format('HH:mm');
  let endTimeMin = moment(dateTime, 'HH:mm').add(30, 'minutes').format('HH:mm');

  const [fromTime, setFromTime] = useState(data?.fromTime ?? dateTime);
  const [toTime, setToTime] = useState(data?.toTime ?? endTimeMin);

  const setStartTime = (e) => {
    const { value } = e;
    let endTime = moment(value, 'HH:mm').add(30, 'minutes').format('HH:mm');
    setFromTime(value);
    setToTime(endTime);
  };
  const setEndTime = (e) => {
    const { value } = e;
    setToTime(value);
  };

  const [allDay, setAllDay] = useState(false);

  const setAllDayMeeting = (e) => {
    const time = moment('12:00 AM', 'h:mm A').format('hh:mm');
    const { checked } = e.target;
    if (checked) {
      setAllDay(true);
      setFromTime(time);
      setToTime(time);
    } else {
      setAllDay(false);
      setFromTime(dateTime);
      setToTime(endTimeMin);
      // setFromTime(moment(eventDetails?.start_time).format('HH:mm'));
      // setToTime(moment(eventDetails?.end_time).format('HH:mm'));
    }
  };

  const selectStyles = {
    container: (style, action) => ({
      ...style,
      width: '100%',
      borderRadius: '5px',
      marginBottom: '1rem',
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
      width: '100%',
      background: '#F8F8F8',
      padding: '0.313rem .25rem 0.313rem 0.5rem',
    }),
    indicatorsContainer: (provide, state) => ({
      ...provide,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: 'none', // hide the down caret icon
    }),
  };

  const selectCommonStyles = {
    container: (style, action) => ({
      ...style,
      width: '100%',
      borderRadius: '5px',
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
      width: '100%',
      background: '#F8F8F8',
      padding: '0.1rem 0.25rem',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '4px 2px',
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: '0px',
      fontSize: '14px',
    }),
    indicatorSeparator: (provide, state) => ({
      ...provide,
      display: 'none',
    }),
    indicatorsContainer: (provide, state) => ({
      ...provide,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="9"
          viewBox="0 0 13 9"
          fill="none"
        >
          <path
            d="M6.33399 8.44815L0.154008 0.363787L12.2771 0.18809L6.33399 8.44815Z"
            fill="#5B5B5B"
          />
        </svg>
      </components.DropdownIndicator>
    );
  };

  const updateProposedStatus = () => {
    // no use of these setFunctions
    data.setAllDay(allDay);
    data.setFromTime(fromTime);
    data.setToTime(toTime);
    data.setFromDate(fromDate);
    data.setToDate(toDate);
    data.setTimeZone(timeZoneSelected);

    updateStatus('PROPOSED', {
      allDay,
      fromDate,
      fromTime,
      toDate,
      toTime,
      timeZoneSelected,
    });
  };

  const [radioValue, setRadioValue] = useState({
    name: 'radio-btn',
    value: data,
  });


  const modalBody = (key) => {
    switch (key) {
      case 'accept':
        return (
          <ModalBody>
            {/* <Textarea
              className={'opt-comment'}
              placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
              maxLength={200}
              onChange={(e) => setCommentMessage(e.target.value)}
            /> */}
            <Box position="relative">
              <Textarea
                className={'opt-comment'}
                placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
                maxLength={200}
                onChange={handleTextareaChange}
                value={commentMessage}
              />
              <Flex justifyContent="flex-end" mt={1}>
                <Text 
                  fontSize="sm" 
                  color={charCount >= 200 ? "red.500" : "gray.500"}
                >
                  {charCount}/200 {charCount >= 200 && `- ${t('otherModules.characterLimitExceeded') || "Character limit exceeded"}`}
                </Text>
              </Flex>
            </Box>
            <ModalFooter px={0}>
              <Box className="text-end">
                <Button
                  variant="secondary"
                  borderRadius="full"
                  onClick={() => setModalOpen(false)}
                  me={3}
                >
                  {t('buttons.cancel') || "Cancel"}
                </Button>
                <Button
                  variant="primary"
                  borderRadius="full"
                  onClick={() => {
                    updateStatus('ACCEPTED', commentMessage);
                    push('/profile/calendar/calendar-listing');
                  }}
                >
                  {t('buttons.send') || "Send"}
                </Button>
              </Box>
            </ModalFooter>
          </ModalBody>
        );
      case 'sendupdate':
        return (
          <ModalBody>
            <Text mb={3}>
              {t('otherModules.attendeeChangesPrompt') || "You have made changes to the list of attendees. Choose one of the following:"}
            </Text>
            <RadioGroup defaultValue={radioValue.value}>
              <Stack spacing={5} direction="column">
                <Radio
                  name="radio-btn"
                  value="UPDATED"
                  defaultChecked={radioValue.value === 'UPDATED' ? true : false}
                  changed={(e) =>
                    setRadioValue({
                      name: 'radio-btn',
                      value: e.target.value,
                    })
                  }
                >
                  {t('otherModules.sendToAddedOrRemoved') || "Send updates only to added or deleted attendees."}
                </Radio>
                <Radio
                  name="radio-btn"
                  value="ALL"
                  defaultChecked={radioValue.value === 'ALL' ? true : false}
                  changed={(e) =>
                    setRadioValue({
                      name: 'radio-btn',
                      value: e.target.value,
                    })
                  }
                >
                  {t('otherModules.sendToAllAttendees') || "Send updates to all attendees."}
                </Radio>
              </Stack>
            </RadioGroup>
            <ModalFooter px={0}>
              <Button
              borderRadius="50px"
                variant="primary"
                me={3}
                onClick={() => updateStatus('SENDUPDATE', radioValue)}
              >
                {t('buttons.send') || "Send"}
              </Button>
              <Button borderRadius="50px" variant="secondary" onClick={() => setModalOpen(false)}>
                {t('buttons.cancel') || "Cancel"}
              </Button>
            </ModalFooter>
          </ModalBody>
        );
      case 'tentative':
        return (
          <ModalBody>
            {/* <storage>Tentative</storage> */}
            {/* <Textarea
              className={'opt-comment'}
              placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
              maxLength={200}
              onChange={(e) => setCommentMessage(e.target.value)}
            /> */}
            <Box position="relative">
              <Textarea
                className={'opt-comment'}
                placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
                maxLength={200}
                onChange={handleTextareaChange}
                value={commentMessage}
              />
              <Flex justifyContent="flex-end" mt={1}>
                <Text 
                  fontSize="sm" 
                  color={charCount >= 200 ? "red.500" : "gray.500"}
                >
                  {charCount}/200 {charCount >= 200 && `- ${t('otherModules.characterLimitExceeded') || "Character limit exceeded"}`}
                </Text>
              </Flex>
            </Box>
            <ModalFooter px={0}>
              <Button
                variant="secondary"
                borderRadius="full"
                me={3}
                onClick={() => setModalOpen(false)}
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                variant="primary"
                borderRadius="full"
                isDisabled={commentMessage?.length===0}
                onClick={() => updateStatus('TENTATIVE', commentMessage)}
              >
                {t('buttons.send') || "Send"}
              </Button>
            </ModalFooter>
          </ModalBody>
        );
      case 'message':
        return (
          <ModalBody>
            {/* <Textarea
              className={'opt-comment'}
              placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
              maxLength={200}
            /> */}
            <Box position="relative">
              <Textarea
                className={'opt-comment'}
                placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
                maxLength={200}
                onChange={handleTextareaChange}
                value={commentMessage}
              />
              <Flex justifyContent="flex-end" mt={1}>
                <Text 
                  fontSize="sm" 
                  color={charCount >= 180 ? "red.500" : "gray.500"}
                >
                  {charCount}/200 {charCount >= 180 && `- ${t('otherModules.characterLimitExceeded') || "Character limit exceeded"}`}
                </Text>
              </Flex>
            </Box>
            {/* <div className="text-end">
              <Button variant="btn-primary" className={'h-36 me-2'} onClick={() => setModalOpen(false)}>
                OK
              </Button>
            </div> */}
          </ModalBody>
        );
      case 'decline':
        return (
          <ModalBody>
            {/* <storage>Decline</storage> */}
            {/* <Textarea
              className={'opt-comment'}
              placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
              maxLength={200}
              onChange={(e) => setCommentMessage(e.target.value)}
            /> */}
            <Box position="relative">
              <Textarea
                className={'opt-comment'}
                placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
                maxLength={200}
                onChange={handleTextareaChange}
                value={commentMessage}
              />
              <Flex justifyContent="flex-end" mt={1}>
                <Text 
                  fontSize="sm" 
                  color={charCount >= 200 ? "red.500" : "gray.500"}
                >
                  {charCount}/200 {charCount >= 200 && `- ${t('otherModules.characterLimitExceeded') || "Character limit exceeded"}`}
                </Text>
              </Flex>
            </Box>
            <ModalFooter px={0}>
              <Button
                borderRadius="full"
                variant="secondary"
                me={3}
                onClick={() => setModalOpen(false)}
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                borderRadius="full"
                variant="primary"
                onClick={() => updateStatus('DECLINED', commentMessage)}
              >
                {t('buttons.send') || "Send"}
              </Button>
            </ModalFooter>
          </ModalBody>
        );
      case 'propose':
        return (
          <ModalBody>
            <Box mb={3}>
              {/* <Flex w="100%" gap={3} alignItems="center">
                <Box flex="2">
                  <DatePicker
                    selected={new Date(fromDate)}
                    onChange={(date) => setFromDate(date)}
                    minDate={new Date()}
                    placeholderText={t('scheduling.selectDateAfter5Days') || "Select a date after 5 days ago"}
                    className={styles.datepicker}
                    dateFormat="EEE, MMMM d, yyyy"
                  />
                </Box>
                <Box flex="1">
                  <Select
                    id={'fromTime'}
                    name="fromTime"
                    styles={selectCommonStyles}
                    options={TIME_FORMATE}
                    title={'fromTime'}
                    value={TIME_FORMATE.filter(function (option) {
                      return option.value === fromTime;
                    })}
                    onChange={setStartTime}
                    disabled={allDay}
                    components={{ DropdownIndicator }}
                  />
                </Box>
                <Box flex="1">
                  <Select
                    id={'timeZone'}
                    name="timeZone"
                    styles={selectCommonStyles}
                    options={timeZone}
                    title={'timeZone'}
                    value={timeZone.filter(function (option) {
                      return option.value === timeZoneSelected;
                    })}
                    onChange={(event) => setTimeZone(event.value)}
                    components={{ DropdownIndicator }}
                  />
                </Box>
              </Flex> */}
              <Flex w="100%" gap={3} alignItems="center" flexWrap="wrap">
                <Box flex={['2 1 60%', '2']}>
                  <DatePicker
                    selected={new Date(fromDate)}
                    onChange={(date) => setFromDate(date)}
                    minDate={new Date()}
                    placeholderText={t('scheduling.selectDateAfter5Days') || "Select a date after 5 days ago"}
                    className={styles.datepicker}
                    dateFormat="EEE, MMMM d, yyyy"
                  />
                </Box>
                <Box flex={['1 1 35%', '1']}>
                  <Select
                    id={'fromTime'}
                    name="fromTime"
                    styles={selectCommonStyles}
                    options={TIME_FORMATE}
                    title={'fromTime'}
                    value={TIME_FORMATE.filter(function (option) {
                      return option.value === fromTime;
                    })}
                    onChange={setStartTime}
                    disabled={allDay}
                    components={{ DropdownIndicator }}
                  />
                </Box>
                <Box flex={['1 1 100%', '1']} mt={['2', '0']}>
                  <Select
                    id={'timeZone'}
                    name="timeZone"
                    styles={selectCommonStyles}
                    options={timeZone}
                    title={'timeZone'}
                    value={timeZone.filter(function (option) {
                      return option.value === timeZoneSelected;
                    })}
                    onChange={(event) => setTimeZone(event.value)}
                    components={{ DropdownIndicator }}
                  />
                </Box>
              </Flex>
            </Box>
            <Box mb={3}>
              {/* <Flex w="100%" gap={3} alignItems="center">
                <Box flex="2">
                  <DatePicker
                    selected={new Date(fromDate)}
                    onChange={(date) => setToDate(date)}
                    minDate={new Date()}
                    placeholderText={t('scheduling.selectDateAfter5Days') || "Select a date after 5 days ago"}
                    className={styles.datepicker}
                    dateFormat="EEE, MMMM d, yyyy"
                  />
                </Box>
                <Box flex="1">
                  <Select
                    id={'toTime'}
                    name="toTime"
                    options={TIME_FORMATE}
                    title={'toTime'}
                    value={TIME_FORMATE.filter(function (option) {
                      return option.value === toTime;
                    })}
                    onChange={setEndTime}
                    containerClass="m-0"
                    disabled={allDay}
                    styles={selectCommonStyles}
                    components={{ DropdownIndicator }}
                  />
                </Box>
                <Box flex="1">
                  <Checkbox
                    checked={allDay}
                    className="m-0"
                    onChange={setAllDayMeeting}
                  >
                    {t('myEvents.allDayMeeting') || "All Day Meeting"}
                  </Checkbox>
                </Box>
              </Flex> */}
              <Flex w="100%" gap={3} alignItems="center" flexWrap="wrap">
                <Box flex={['2 1 60%', '2']}>
                  <DatePicker
                    selected={new Date(fromDate)}
                    onChange={(date) => setToDate(date)}
                    minDate={new Date()}
                    placeholderText={t('scheduling.selectDateAfter5Days') || "Select a date after 5 days ago"}
                    className={styles.datepicker}
                    dateFormat="EEE, MMMM d, yyyy"
                  />
                </Box>
                <Box flex={['1 1 35%', '1']}>
                  <Select
                    id={'toTime'}
                    name="toTime"
                    options={TIME_FORMATE}
                    title={'toTime'}
                    value={TIME_FORMATE.filter(function (option) {
                      return option.value === toTime;
                    })}
                    onChange={setEndTime}
                    containerClass="m-0"
                    disabled={allDay}
                    styles={selectCommonStyles}
                    components={{ DropdownIndicator }}
                  />
                </Box>
                <Box flex={['1 1 100%', '1']} mt={['2', '0']}>
                  <Checkbox
                    checked={allDay}
                    className="m-0"
                    onChange={setAllDayMeeting}
                  >
                    {t('myEvents.allDayMeeting') || "All Day Meeting"}
                  </Checkbox>
                </Box>
              </Flex>
            </Box>

            <ModalFooter px={0}>
              <Button
                variant="secondary"
                borderRadius='full'
                me={3}
                onClick={() => setModalOpen(false)}
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button 
                // isDisabled={(data?.fromTime===fromTime) && (data?.toTime===toTime)} 
                variant="primary" 
                borderRadius='full' 
                onClick={() => updateProposedStatus()}
              >
                {t('buttons.send') || "Send"}
              </Button>
            </ModalFooter>
          </ModalBody>
        );
      default:
        break;
    }
  };
  return modalBody(modalType);
};

export default CalendarModalPopups;
